// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00d04daf","897":"6e264af7"}[chunkId] + ".chunk.js";
};